import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { px2rem } from '@/theme';

import { ReactComponent as InfoBadge } from '@/assets/icons/info-badge.svg';
export const Badge = styled(InfoBadge)`
  ${({ theme }) => css`
    width: ${px2rem(12)};
    margin-left: ${theme.spacing(1)};
  `}

  &:hover {
    cursor: pointer;
  }
`;
export const Wrapper = styled(Box)<{ $loading: boolean }>`
  ${({ $loading }) =>
    $loading &&
    css`
      visibility: hidden;
    `}
`;
